import { createPortal } from 'react-dom'
import { useTranslation } from 'react-i18next'
import Modal from '../../../ui/Modal'

interface GroupDeleteDialogProps {
  isOpen: boolean
  onClose: () => void
  onKeepChildren: () => void
  onDeleteAll: () => void
  childCount: number
}

export function GroupDeleteDialog({
  isOpen,
  onClose,
  onKeepChildren,
  onDeleteAll,
  childCount,
}: GroupDeleteDialogProps) {
  const { t } = useTranslation('canvas')

  if (!isOpen) return null

  return createPortal(
    <Modal isOpen={isOpen} onClose={onClose} title={t('groupDeleteDialog.deleteGroup')} size="sm">
      <p className="text-sm text-muted-foreground mb-4">
        {childCount > 0
          ? t('groupDeleteDialog.whatToDoWithChildren')
          : t('groupDeleteDialog.confirmDeleteGroup')}
      </p>
      <div className="flex gap-2 justify-end">
        <button
          onClick={onClose}
          className="px-3 py-1.5 text-sm rounded-md border border-border hover:bg-surface-2 transition-colors"
        >
          {t('groupDeleteDialog.cancel')}
        </button>
        {childCount > 0 && (
          <button
            onClick={onKeepChildren}
            className="px-3 py-1.5 text-sm rounded-md border border-border hover:bg-surface-2 transition-colors"
          >
            {t('groupDeleteDialog.keepChildren')}
          </button>
        )}
        <button
          onClick={onDeleteAll}
          className="px-3 py-1.5 text-sm rounded-md bg-red-600 hover:bg-red-700 text-white transition-colors"
        >
          {t('groupDeleteDialog.deleteAll')}
        </button>
      </div>
    </Modal>,
    document.body,
  )
}
